/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_health_consent_restricted_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Without consent to health data you cannot add or view data. Your account stays active and stored data is not deleted automatically.`)
};

const pl_health_consent_restricted_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez zgody na dane o zdrowiu nie możesz dodawać ani przeglądać danych. Konto pozostaje aktywne, a zapisane dane nie są automatycznie usuwane.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const health_consent_restricted_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.health_consent_restricted_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("health_consent_restricted_body", locale)
	if (locale === "en") return en_health_consent_restricted_body(inputs)
	return pl_health_consent_restricted_body(inputs)
};